import { combineReducers } from 'redux'

import { reducer as admins } from '../redux/adminsSlice'
import { reducer as labels } from '../redux/labelsSlice'
import { reducer as notifications } from '../redux/notificationsSlice'
import { reducer as state } from '../redux/stateSlice'

import { AiConversationsRateReducer } from './aiConversationsRate'
import chatSettings from './chatSettings'
import counters from './counters'
import { messagesReducer as messages } from './messagesSlice'
import { chatScheduledMessagesReducer as scheduledMessages } from './scheduledMessages'
import { searchReducer as search } from './searchSlice'
import { threadReducer as threads } from './slices/threadListSlice'

export default combineReducers({
  admins,
  threads,
  messages,
  labels,
  notifications,
  search,
  chatSettings,
  counters,
  state,
  scheduledMessages,
  aiConversationsRate: AiConversationsRateReducer,
})
